import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import './search-select.scss';
import Button from '../button/button';
import {
  AcceptIcon,
  EditIcon,
  SearchIcon,
  ShortDownIcon,
  // CloseIcon,
} from '../icons/icons';
// import AdvancePopover from '../advance-popover/advance-popover';
import OutsideClick from '../outside-click/outside-click';

function SearchSelect({
  label,
  data,
  onChange,
  onClick,
  defaultValue,
  selectProduct,
  t,
  showFooterMessage,
  classNames,
  enableLabel,
  selectStyle,
  containerClassName,
  required,
  placeholder,
  arrowColor,
  errorMessage,
  children,
  disabled,
  enableRemove,
  handleApplyAll,
  enableBulk,
}) {
  const selectPackageType = useRef(null);
  const [query, setQuery] = useState('');
  const [selectedLabel, setSelectedlabel] = useState(defaultValue);
  const [eventValue, setEventValue] = useState();
  // const [keepOpenPopover, setKeepOpenPopover] = useState(false);
  const [isToggle, setIsToggle] = useState(!selectProduct);
  const [selectedValue, setSelectedValue] = useState('');
  const selectRef = useRef(null);
  const optionBox = useRef(null);
  const selectListRef = useState(null);
  const [selectListWidth, setSelectListWidth] = useState(0);
  const [optionTop, setOptionTop] = useState(0);
  const searchbox = useRef(null);

  const getPosition = () => {
    setEventValue(selectPackageType.current.getBoundingClientRect());
    const el = document.querySelector('.dialog-wrapper');
    if (el) {
      el.style.overflow = 'hidden';
    }

    document.body.style.overflow = 'hidden';
    setTimeout(() => {
      if (optionBox.current) {
        const optionBoxHeight =
          optionBox.current.getBoundingClientRect().height;
        if (
          selectPackageType.current.getBoundingClientRect().top +
            selectPackageType.current.getBoundingClientRect().height +
            optionBoxHeight >
          window.innerHeight
        ) {
          setOptionTop(
            selectPackageType.current.getBoundingClientRect().top -
              optionBoxHeight
          );
        } else {
          setOptionTop(
            selectPackageType.current.getBoundingClientRect().top +
              selectPackageType.current.getBoundingClientRect().height
          );
        }
      }
    }, 100);
  };

  useEffect(() => {
    setSelectedlabel(defaultValue);
    if (enableLabel) {
      setSelectListWidth(selectRef.current?.getBoundingClientRect().width);
    } else {
      setSelectListWidth(null);
    }
  }, [defaultValue, enableLabel]);

  const togglePopover = () => {
    setEventValue(selectPackageType.current.getBoundingClientRect());
    document.body.style.overflow = 'hidden';
    setQuery('');
    getPosition();
    // setTimeout(() => {
    if (enableLabel) {
      setSelectListWidth(selectRef.current?.getBoundingClientRect().width);
    } else {
      setSelectListWidth(null);
    }
    // }, 100);
  };

  const handleChange = (e) => {
    // setQuery(e.target.value?.toLowerCase());
    // setSelectedlabel('');
    setSelectedValue(e.target.value);
    togglePopover(e);
    // setKeepOpenPopover(true);
    getPosition();
    searchbox.current.value = e.target.value;
    setQuery(e.target.value.toLowerCase());
  };

  // const handleClearQuery = () => {
  //   setQuery('');
  //   setSelectedValue('');
  //   if (selectListRef.current) {
  //     const inputElement = selectListRef.current.querySelector('input');
  //     if (inputElement) {
  //       inputElement.focus();
  //     }
  //   }
  // };

  const handleRemoveSelectedValue = () => {
    setSelectedlabel('');
    setSelectedValue('');
    setQuery('');
    setIsToggle(true);
    onChange({ target: { value: '', label: '' } });
    setTimeout(() => {
      if (selectPackageType.current) {
        selectPackageType.current.focus();
      }
    }, 200);
  };

  const getlabel = (e) => {
    const target = e?.target;
    setSelectedlabel(
      target?.innerText
      // e?.target?.value?.startsWith('New_Package_Type')
      //   ? e?.target?.innerText
      //   : e?.target?.value
    );

    onChange({
      target: {
        value: target?.value,
        label: target?.innerText,
      },
    });

    setEventValue(null);
    // setKeepOpenPopover(false);
    setIsToggle(false);
    setQuery(target?.innerText?.toLowerCase());
  };

  const getApplyAllLabel = (e) => {
    const target = e?.target;
    handleApplyAll({
      target: {
        value: target?.value,
        label: target?.innerText,
      },
    });
    setEventValue(null);
    // setKeepOpenPopover(false);
    setIsToggle(false);
    setQuery(target?.innerText?.toLowerCase());
  };

  const handleClose = () => {
    setEventValue(null);
    document.body.style.overflow = 'auto';
    const el = document.querySelector('.dialog-wrapper');
    if (el) {
      el.style.overflow = 'auto';
    }
    // setKeepOpenPopover(false);
    // setSelectedlabel(!selectedLabel ? defaultValue : selectedLabel);
    if (selectedLabel === '' && query !== '') {
      setQuery('');
    } else if (selectedLabel !== '' && query !== selectedLabel?.toLowerCase()) {
      // If a label is selected, but query is different, reset query to selected label
      setQuery(selectedLabel?.toLowerCase());
    }
  };

  const filteredDDList = data?.filter((val) =>
    val?.label?.toLowerCase()?.includes(query)
  );

  const displayValueWhenSelectedLabelIsEmpty = placeholder || label;

  // const shouldShowAcceptButton = classNames && !filteredDDList?.length;

  return (
    <>
      {(enableLabel || isToggle || !selectedLabel) && (
        <div
          className={`search-select${
            enableLabel || selectStyle ? ' select' : ''
          }${containerClassName ? ` ${containerClassName}` : ''}${
            disabled || eventValue ? ' disablled' : ''
          }`}
          ref={selectRef}
        >
          {enableLabel && label && (
            <div className="d-flex justify-between align-center">
              <label>
                {label} {required && <span className="required">*</span>}
              </label>
              {children}
            </div>
          )}
          <div className="search-select-box select">
            <button
              className={`search-select-button ${classNames}${
                enableRemove && selectedLabel !== '' ? ' w-100-40' : ' w-100-20'
              }${enableLabel ? '' : ' pl-10'}`}
              type="button"
              onClick={togglePopover}
              id="actionPopover"
              ref={selectPackageType}
              disabled={disabled || eventValue}
            >
              <span className="search-select-value text-limit disable-pointer">
                {selectedLabel === ''
                  ? displayValueWhenSelectedLabelIsEmpty
                  : selectedLabel}
              </span>
            </button>
            {enableRemove && selectedLabel && (
              <button
                type="button"
                className="clear-selected"
                onClick={(e) => {
                  e.stopPropagation();
                  handleRemoveSelectedValue();
                }}
                style={{ color: arrowColor }}
                disabled={disabled || eventValue}
              >
                &times;
              </button>
            )}
            {enableLabel && (
              <button
                className="arrow bg-transparent border-none d-flex px-0"
                type="button"
                onClick={togglePopover}
                disabled={disabled || eventValue}
              >
                <ShortDownIcon
                  color={arrowColor || enableLabel ? '' : '#0088FA'}
                />
              </button>
            )}
            {!selectedLabel
              ? !enableLabel && (
                  <button
                    className="arrow bg-transparent border-none d-flex px-0"
                    type="button"
                    onClick={togglePopover}
                    disabled={disabled || eventValue}
                  >
                    <ShortDownIcon
                      color={arrowColor || enableLabel ? '' : '#0088FA'}
                    />
                  </button>
                )
              : !enableLabel && (
                  <Button
                    icon={<EditIcon />}
                    className="p-0 ml-10 position-absolute t-0 r-0 b-0 w-auto m-w-auto pl-0 mr-5"
                    onClick={(e) => {
                      setIsToggle(true);
                      togglePopover(e);
                    }}
                    disabled={
                      disabled ||
                      eventValue ||
                      (!enableLabel && !isToggle && selectedLabel)
                    }
                  />
                )}
          </div>
        </div>
      )}
      {!enableLabel && !isToggle && selectedLabel && (
        <div
          className={`search-select${
            enableLabel || selectStyle ? ' select' : ''
          }${containerClassName ? ` ${containerClassName}` : ''}${
            disabled || eventValue ? ' disablled' : ''
          }`}
          ref={selectRef}
        >
          {enableLabel && <label>{label}</label>}
          <span className={`search-select-box ${classNames}`}>
            <span
              className={`search-select-value pl-6 text-limit${
                disabled ? ' w-100' : ''
              }${
                enableRemove && selectedLabel !== '' ? ' w-100-40' : ' w-100'
              }`}
            >
              {selectedLabel === '' ? label : selectedLabel}
            </span>
            {!disabled && enableRemove && (
              <button
                type="button"
                className="clear-selected"
                style={{ color: arrowColor }}
                onClick={(e) => {
                  e.stopPropagation();
                  handleRemoveSelectedValue();
                }}
              >
                &times;
              </button>
            )}
            {!disabled && (
              <Button
                icon={<EditIcon />}
                className="p-0 ml-10 position-absolute t-0 r-0 b-0 w-auto m-w-auto pl-0 mr-5"
                onClick={(e) => {
                  setIsToggle(true);
                  togglePopover(e);
                }}
                disabled={disabled || eventValue}
              />
            )}
          </span>
        </div>
      )}
      {errorMessage !== '' && <p className="error-message">{errorMessage}</p>}
      {eventValue && (
        <>
          <div className="search-select-mask" />
          <OutsideClick onClickOutside={handleClose}>
            <div
              className={`search-select-popover${enableLabel ? ' select' : ''}`}
              style={{
                left: eventValue.left,
                top: optionTop,
                width: selectListWidth,
              }}
              ref={optionBox}
            >
              <div className="search-select-search" ref={selectListRef}>
                <input
                  type="text"
                  onChange={handleChange}
                  ref={searchbox}
                  className="search-select-search-box"
                />
                {classNames && query?.trim() && !filteredDDList?.length ? (
                  <button
                    className="accept"
                    type="button"
                    disabled={query === ''}
                    onClick={() => {
                      getlabel({
                        target: { value: selectedValue, label: selectedLabel },
                      });
                      handleClose();
                    }}
                  >
                    <AcceptIcon color="#0288FA" />
                  </button>
                ) : (
                  <span className="arrow">
                    <SearchIcon />
                  </span>
                )}
              </div>

              {filteredDDList?.length ? (
                <ul className={enableBulk ? 'enaable-bulk' : ''}>
                  {filteredDDList.map((val) => (
                    <li key={val.value}>
                      <button
                        type="button"
                        value={val.value}
                        onClick={(e) => {
                          getlabel(e);
                          handleClose();
                        }}
                      >
                        <span className="text">{val?.label}</span>
                      </button>
                      {enableBulk && (
                        <button
                          type="button"
                          value={val.value}
                          onClick={(e) => {
                            getApplyAllLabel(e);
                            handleClose();
                          }}
                          className="apply-all"
                        >
                          <span className="text">
                            {t(
                              'manageordersscreen.filterbtn.filteroption.applyall'
                            )}
                          </span>
                        </button>
                      )}
                    </li>
                  ))}
                </ul>
              ) : null}
              {showFooterMessage && (
                <p>
                  {t(
                    'manageordersscreen.sendbookingdetails.packagetype.cantfindpackage'
                  )}{' '}
                  <br />{' '}
                  {t(
                    'manageordersscreen.sendbookingdetails.packagetype.dontworry'
                  )}{' '}
                  <button type="button" onClick={onClick}>
                    {' '}
                    {t(
                      'manageordersscreen.sendbookingdetails.packagetype.nextstep'
                    )}
                  </button>
                  .
                </p>
              )}
            </div>
          </OutsideClick>
        </>
      )}
      {/* {false && (
        <AdvancePopover
          reference="actionPopover"
          getEvent={eventValue}
          closePopover={handleClose}
          className={`search-select-popover${enableLabel ? ' select' : ''}`}
          popoverOpen={keepOpenPopover}
          placement="self-bottom"
          setMinWidth={selectListWidth}
        >
          <div className="search-select-search" ref={selectListRef}>
            <input type="text" onChange={handleChange} value={query} />
            {classNames && query?.trim() && !filteredDDList?.length ? (
              <button
                className="accept"
                type="button"
                disabled={!query?.trim()}
                onClick={() =>
                  getlabel({
                    target: { value: selectedValue, label: selectedValue },
                  })
                }
              >
                <AcceptIcon color="#0288FA" />
              </button>
            ) : (
              <span className="arrow">
                <SearchIcon />
              </span>
            )}
          </div>

          {filteredDDList?.length ? (
            <ul>
              {filteredDDList.map((val) => (
                <li key={val.value}>
                  <button type="button" value={val.value} onClick={getlabel}>
                    <span className="text">{val?.label}</span>
                  </button>
                </li>
              ))}
            </ul>
          ) : null}
          {showFooterMessage && (
            <p>
              {t(
                'manageordersscreen.sendbookingdetails.packagetype.cantfindpackage'
              )}{' '}
              <br />{' '}
              {t('manageordersscreen.sendbookingdetails.packagetype.dontworry')}{' '}
              <button type="button" onClick={onClick}>
                {' '}
                {t(
                  'manageordersscreen.sendbookingdetails.packagetype.nextstep'
                )}
              </button>
              .
            </p>
          )}
        </AdvancePopover>
      )} */}
    </>
  );
}

export default React.memo(SearchSelect);
SearchSelect.propTypes = {
  label: PropTypes.string,
  data: PropTypes.instanceOf(Array),
  onChange: PropTypes.func,
  onClick: PropTypes.func,
  defaultValue: PropTypes.string,
  selectProduct: PropTypes.bool,
  t: PropTypes.func,
  showFooterMessage: PropTypes.bool,
  classNames: PropTypes.string,
  enableLabel: PropTypes.bool,
  selectStyle: PropTypes.bool,
  containerClassName: PropTypes.string,
  required: PropTypes.bool,
  placeholder: PropTypes.string,
  arrowColor: PropTypes.string,
  errorMessage: PropTypes.string,
  children: PropTypes.node,
  disabled: PropTypes.bool,
  enableRemove: PropTypes.bool,
  handleApplyAll: PropTypes.string,
  enableBulk: PropTypes.bool,
};
SearchSelect.defaultProps = {
  label: '',
  data: [],
  onChange: () => {},
  onClick: () => {},
  defaultValue: '',
  selectProduct: false,
  t: () => {},
  showFooterMessage: true,
  classNames: '',
  enableLabel: false,
  selectStyle: false,
  containerClassName: '',
  required: false,
  placeholder: '',
  arrowColor: '',
  errorMessage: '',
  children: null,
  disabled: false,
  enableRemove: false,
  handleApplyAll: () => {},
  enableBulk: false,
};
